// The office's collider adapter. Grid geometry is shared with the server; rooms and landing choices stay here.
import { gridCollider } from '../../../packages/holt-navigation/src/grid.js';
export { SEA_MARGIN, BODY, feet } from '../../../packages/holt-navigation/src/grid.js';

export const WALK_SPEED = 6.5, BOAT_SPEED = 8; // tiles a second (rules.ts: WALK_SPEED, BOAT_SPEED)

export function collider(MAP) {
  const grid = gridCollider(MAP), { water, footOk } = grid;
  /** The room an otter at position (x, y) is in, by its feet (rules.ts: feetIn). */
  const zoneAt = (x, y) => MAP.zones.find((z) => x + 0.5 >= z.x && x + 0.5 < z.x + z.w && y + 0.8 >= z.y && y + 0.8 < z.y + z.h) || null;
  /** Sea right next to the deck: where a boat can land. */
  const shoreWater = (x, y) => water(x, y) && [[1, 0], [-1, 0], [0, 1], [0, -1]].some(([dx, dy]) => footOk(x + dx, y + dy));
  return { ...grid, zoneAt, shoreWater };
}
